(function () {
    const svg = document.querySelector('.bg-dots');

    // ====== Paramètres principaux ======
    const BASELINE_WIDTH = 1440;  // 1440px → 100 points
    const BASELINE_COUNT = 100;
    const MAX_MULTIPLIER = 3.0;   // sécurité (éviter >300% de la baseline)
    const MIN_MULTIPLIER = 0.4;   // sécurité (éviter trop peu de points)

    const R_MIN = 0.25;    // rayon min px  (diamètre 0.5)
    const R_MAX = 1.0;     // rayon max px  (diamètre 2)
    const DUR_MIN = 2.6;   // s
    const DUR_MAX = 5.8;   // s
    const LIFETIME_MIN = 7.0; // s
    const LIFETIME_MAX = 13.0; // s
    const LEAVE_FADE_MS = 800; // ms

    // Les espacements s’adaptent à la densité : spacing ≈ sqrt(area / target)
    function computeSpacing(target) {
        const w = window.innerWidth;
        const h = window.innerHeight;
        if (target <= 0) return 100;
        const area = w * h;
        const cell = Math.sqrt(area / target);
        // léger facteur pour plus d’air entre les points
        return Math.max(60, Math.min(200, cell * 1.05));
    }

    function fitViewBox() {
        svg.setAttribute('viewBox', `0 0 ${window.innerWidth} ${window.innerHeight}`);
        svg.setAttribute('preserveAspectRatio', 'none'); // 100% largeur/hauteur exactes
    }
    fitViewBox();
    window.addEventListener('resize', () => {
        fitViewBox();
        desiredCount = computeDesiredCount();
    });

    function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
    function rand(a, b) { return a + Math.random() * (b - a); }
    function rndInt(a, b) { return Math.floor(rand(a, b + 1)); }

    function computeDesiredCount() {
        const mult = clamp(window.innerWidth / BASELINE_WIDTH, MIN_MULTIPLIER, MAX_MULTIPLIER);
        return Math.max(1, Math.round(BASELINE_COUNT * mult));
    }

    // Répartition harmonieuse : grille + jitter basé sur l’espacement courant
    function pickPos(spacing) {
        const w = window.innerWidth, h = window.innerHeight;
        const jitter = Math.min(0.7 * spacing, 60); // limite le jitter
        const cols = Math.max(1, Math.floor(w / spacing));
        const rows = Math.max(1, Math.floor(h / spacing));
        const c = rndInt(0, cols - 1);
        const r = rndInt(0, rows - 1);
        let x = c * spacing + spacing / 2 + rand(-jitter, jitter);
        let y = r * spacing + spacing / 2 + rand(-jitter, jitter);
        x = Math.max(0, Math.min(w, x));
        y = Math.max(0, Math.min(h, y));
        return { x, y };
    }

    // État
    let desiredCount = computeDesiredCount();
    const activeDots = new Set();

    function spawnDot(spacing) {
        // crée un point avec entrée douce + pulse
        const { x, y } = pickPos(spacing);
        const r = rand(R_MIN, R_MAX);
        const dur = rand(DUR_MIN, DUR_MAX);
        const delay = -rand(0, dur);
        const startScale = rand(0.5, 1.0);
        const finalOpacity = rand(0.35, 1.0);

        const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
        c.setAttribute('class', 'dot');
        c.setAttribute('cx', x.toFixed(2));
        c.setAttribute('cy', y.toFixed(2));
        c.setAttribute('r', r.toFixed(3));
        // variables CSS personnalisées pour l’animation d’entrée
        c.style.setProperty('--scale-start', startScale.toFixed(3));
        c.style.setProperty('--opacity-final', finalOpacity.toFixed(3));

        // IMPORTANT : au lieu d’une classe fixe, on définit toute l’animation inline pour chaîner "enter" + "pulse"
        // enter : 320–420ms, puis pulse infini avec délai négatif pour désynchroniser
        const enterMs = rndInt(320, 420);
        c.style.animation = `dotEnter ${enterMs}ms ease both, dotPulse ${dur.toFixed(2)}s ease-in-out ${delay.toFixed(2)}s infinite alternate`;

        svg.appendChild(c);
        activeDots.add(c);

        // planifie la suppression (avec fade-out) puis remplacement
        const life = rand(LIFETIME_MIN, LIFETIME_MAX);
        setTimeout(() => removeDot(c), life * 1000);
    }

    function removeDot(dot) {
        if (!activeDots.has(dot)) return;
        dot.classList.add('is-leaving');
        setTimeout(() => {
            if (dot.parentNode) dot.parentNode.removeChild(dot);
            activeDots.delete(dot);
        }, LEAVE_FADE_MS);
    }

    // Boucle d’équilibrage : vise "desiredCount"
    const TICK_MS = 160;
    setInterval(() => {
        desiredCount = computeDesiredCount();
        const spacing = computeSpacing(desiredCount);
        const n = activeDots.size;

        if (n < desiredCount) {
            // injecter plusieurs points d’un coup si on est loin du compte
            const deficit = desiredCount - n;
            const burst = Math.min(8, Math.max(1, Math.ceil(deficit / 6)));
            for (let i = 0; i < burst; i++) spawnDot(spacing);
        } else if (n > desiredCount) {
            // retirer progressivement l’excédent
            const surplus = n - desiredCount;
            const toRemove = Math.min(4, Math.max(1, Math.ceil(surplus / 8)));
            const arr = Array.from(activeDots);
            for (let i = 0; i < toRemove; i++) {
                const victim = arr[rndInt(0, arr.length - 1)];
                removeDot(victim);
            }
        }
    }, TICK_MS);

    // Préchargement initial
    (function preload() {
        const spacing = computeSpacing(desiredCount);
        for (let i = 0; i < desiredCount; i++) {
            setTimeout(() => spawnDot(spacing), i * 12); // montée douce
        }
    })();
})();

function _s(o, i, p, l) {
    void 0 === i && (i = 400),
        void 0 === l && (l = !1),
        (o.style.overflow = "hidden"),
        l && (o.style.display = "block");
    var n,
        t = window.getComputedStyle(o),
        s = parseFloat(t.getPropertyValue("height")),
        a = parseFloat(t.getPropertyValue("padding-top")),
        r = parseFloat(t.getPropertyValue("padding-bottom")),
        y = parseFloat(t.getPropertyValue("margin-top")),
        d = parseFloat(t.getPropertyValue("margin-bottom")),
        g = s / i,
        m = a / i,
        h = r / i,
        u = y / i,
        x = d / i;
    window.requestAnimationFrame(function t(e) {
        void 0 === n && (n = e);
        e -= n;
        l
            ? ((o.style.height = g * e + "px"),
                (o.style.paddingTop = m * e + "px"),
                (o.style.paddingBottom = h * e + "px"),
                (o.style.marginTop = u * e + "px"),
                (o.style.marginBottom = x * e + "px"))
            : ((o.style.height = s - g * e + "px"),
                (o.style.paddingTop = a - m * e + "px"),
                (o.style.paddingBottom = r - h * e + "px"),
                (o.style.marginTop = y - u * e + "px"),
                (o.style.marginBottom = d - x * e + "px")),
            i <= e
                ? ((o.style.height = ""),
                    (o.style.paddingTop = ""),
                    (o.style.paddingBottom = ""),
                    (o.style.marginTop = ""),
                    (o.style.marginBottom = ""),
                    (o.style.overflow = ""),
                    l || (o.style.display = "none"),
                    "function" == typeof p && p())
                : window.requestAnimationFrame(t);
    });
}
(HTMLElement.prototype.slideToggle = function (t, e) {
    0 === this.clientHeight ? _s(this, t, e, !0) : _s(this, t, e);
}),
    (HTMLElement.prototype.slideUp = function (t, e) {
        _s(this, t, e);
    }),
    (HTMLElement.prototype.slideDown = function (t, e) {
        _s(this, t, e, !0);
    });

(function anchorHandler() {
    // one delegate, stop interfering with external links
    document.addEventListener('click', (e) => {
        const a = e.target.closest('a[href*="#"]');
        if (!a) return;

        const href = a.getAttribute('href');
        if (!href || href === '#' || href === '/#') return;

        // only handle same-origin or path-only anchors
        try {
            const url = new URL(href, window.location.origin);
            if (url.origin !== window.location.origin) return; // external
            if (!url.hash) return;

            // normalize id from "#section" or "/#section"
            const targetId = url.hash.replace(/^#/, '');
            if (!targetId) return;

            // detect "home" path, supports /, /fr, /fr-CA
            const isHomePath = (p) => p === '/' || /^\/[a-z]{2}(-[A-Z]{2})?\/?$/.test(p);
            const onHome = isHomePath(window.location.pathname);

            const target = document.querySelector(`#${targetId}`);
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;


            if (onHome) {
                e.preventDefault();
                // smooth scroll on current page
                const targetEl = document.getElementById(targetId);
                if (targetEl) {

                    window.scrollTo({
                        top: targetPosition - 100, // Adds 100px offset
                        behavior: 'smooth'
                    });
                }
            } else {
                // redirect to same locale prefix + #target
                e.preventDefault();
                const segments = window.location.pathname.split('/').filter(Boolean);
                const maybeLocale = segments[0];
                const localePrefix = /^[a-z]{2}(-[A-Z]{2})?$/.test(maybeLocale) ? `/${maybeLocale}` : '';
                window.location.href = `${localePrefix || ''}/#${targetId}`;
            }
        } catch (_) {
            // ignore malformed
        }
    });
})();

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-product-review-note]').forEach((el) => {
        const rating = Math.max(0, Math.min(5, parseFloat(el.getAttribute('data-product-review-note') || '0')));
        const svg = el.querySelector('svg');
        if (!svg) return;

        const stars = svg.querySelectorAll('path');
        const defs = svg.querySelector('defs') || (() => {
            const d = document.createElementNS('http://www.w3.org/2000/svg', 'defs');
            svg.insertBefore(d, svg.firstChild);
            return d;
        })();

        stars.forEach((star, idx) => {
            if (idx < Math.floor(rating)) {
                star.setAttribute('fill', '#FF4E00');
            } else if (idx === Math.floor(rating) && rating % 1 !== 0) {
                const frac = rating % 1;
                const gradId = `partial-star-${idx}-${Date.now()}`;
                const grad = document.createElementNS('http://www.w3.org/2000/svg', 'linearGradient');
                grad.setAttribute('id', gradId);
                grad.setAttribute('x1', '0');
                grad.setAttribute('x2', '1');
                grad.setAttribute('y1', '0');
                grad.setAttribute('y2', '0');
                const stop1 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                stop1.setAttribute('offset', `${frac * 100}%`);
                stop1.setAttribute('stop-color', '#FF4E00');
                const stop2 = document.createElementNS('http://www.w3.org/2000/svg', 'stop');
                stop2.setAttribute('offset', `${frac * 100}%`);
                stop2.setAttribute('stop-color', '#D3D3D3');
                grad.appendChild(stop1);
                grad.appendChild(stop2);
                defs.appendChild(grad);
                star.setAttribute('fill', `url(#${gradId})`);
            } else {
                star.setAttribute('fill', '#D3D3D3');
            }
        });
    });
});

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    // Délégation: quand on clique un label custom, on force le checked + change
    this.addEventListener('click', (e) => {
      const label = e.target.closest('label');
      if (!label || !this.contains(label)) return;

      let input = null;
      const forId = label.getAttribute('for');
      if (forId) {
        try { input = this.querySelector(`#${CSS.escape(forId)}`); } catch { input = this.querySelector(`#${forId}`); }
      }
      if (!input) input = label.querySelector('input[type="radio"],input[type="checkbox"]');
      if (!input) {
        const prev = label.previousElementSibling;
        if (prev && prev.matches('input[type="radio"],input[type="checkbox"]')) input = prev;
      }
      if (!input || input.disabled) return;

      if (input.type === 'radio') {
        const name = input.name;
        const group = this.querySelectorAll(`input[type="radio"][name="${CSS.escape(name)}"]`);
        group.forEach(r => { r.checked = (r === input); });
      } else {
        input.checked = !input.checked;
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  onVariantChange = () => {
    this.updateOptions();
    this.updateMasterId();

    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      return;
    }

    // >>> Évènement global (pont avec ProductTemplate & autres) <<<
    document.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: {
        section: this.dataset.section,
        url: this.dataset.url,
        productId: this.currentVariant.product_id || this.dataset.productId,
        variantId: this.currentVariant.id,
        price: this.currentVariant.price,
        compare_at_price: this.currentVariant.compare_at_price,
        featured_media_id: this.currentVariant.featured_media?.id || null,
        image: this.currentVariant.featured_image?.src || this.currentVariant.image || null
      }
    }));

    // Comportement thème
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateShareUrl();
  };

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    const data = this.getVariantData();
    this.currentVariant = data.find((variant) => {
      return !variant.options.map((opt, i) => this.options[i] === opt).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return;
    const galleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    galleries.forEach(g => g.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (shareButton?.updateUrl) {
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }

  updateVariantInput() {
    const forms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    forms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  updateVariantStatuses() {
    const firstChecked = this.querySelector(':checked');
    if (!firstChecked) return;

    const selectedOptionOneVariants = this.variantData.filter(v => firstChecked.value === v.option1);
    const wrappers = [...this.querySelectorAll('.product-form__input')];
    wrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const prevChecked = wrappers[index - 1].querySelector(':checked');
      if (!prevChecked) return;
      const prevVal = prevChecked.value;
      const availValues = selectedOptionOneVariants
        .filter(v => v.available && v[`option${index}`] === prevVal)
        .map(v => v[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availValues);
    });
  }

  setInputAvailability(listOfOptions, avail) {
    listOfOptions.forEach(input => {
      const val = input.getAttribute('value');
      if (!val) return;
      input.innerText = avail.includes(val)
        ? val
        : window.variantStrings.unavailable_with_option.replace('[value]', val);
    });
  }

  updatePickupAvailability() {
    const pick = document.querySelector('pickup-availability');
    if (!pick) return;
    if (this.currentVariant?.available) pick.fetchAvailability(this.currentVariant.id);
    else { pick.removeAttribute('available'); pick.innerHTML = ''; }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    section?.querySelector('product-form')?.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    // (garde ton code interne ici si besoin)
    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection || this.dataset.section}`)
      .then(r => r.text()).catch(() => {});
  }

  toggleAddButton(disable = true, text) {
    const form = document.getElementById(`product-form-${this.dataset.section}`);
    if (!form) return;
    const btn = form.querySelector('[name="add"]');
    const span = btn?.querySelector('span');
    if (!btn) return;
    if (disable) { btn.setAttribute('disabled', 'disabled'); if (text && span) span.textContent = text; }
    else { btn.removeAttribute('disabled'); if (span) span.textContent = window.variantStrings.addToCart; }
  }

  setUnavailable() {
    const candidate = this.querySelector('.variant_picker--product:not(.hidden) [data-option-position="2"] input:not(.disabled)');
    if (candidate) {
      candidate.checked = true;
      candidate.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  setInputAvailability(listOfOptions, avail) {
    listOfOptions.forEach(input => {
      const val = input.getAttribute('value');
      const ok = avail.includes(val);
      input.classList.toggle('disabled', !ok);
    });
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fs) => {
      const checked = fs.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    });
  }
}
customElements.define('variant-radios', VariantRadios);
